import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasProduct;

const mapStateToProps = (state: ApplicationState) => ({
    variantProductState: getProductState(state, state.pages.productDetails.selectedProductId),
});

export interface ProductDetailsStoreLocationStyles {
    label?: InjectableCss;
    value?: TypographyPresentationProps;
}

export const productDetailsStoreLocationStyles: ProductDetailsStoreLocationStyles = {
    label: {
        css: css`
            font-size: 15px;
        `,
    },
    value: {
        css: css`
            font-size: 15px;
            font-weight: bold;
        `,
    },
};

const styles = productDetailsStoreLocationStyles;

const ProductDetailsStoreLocation: React.FC<Props> = ({ product, variantProductState }) => {
    let properties = null;
    
    if(variantProductState?.value?.properties && Object.keys(variantProductState?.value?.properties).length > 0) {
        properties = variantProductState?.value?.properties;
    } else {
        properties = product.properties;
    }

    if(!properties?.productSelectedStore || properties.productSelectedStore === '') {
        return null;
    }

    return (
        <StyledWrapper data-test-selector="selectedStoreLocation">
            <Typography {...styles.label}>{translate("Location at Selected Store:")}</Typography>
            <Typography {...styles.value}>{` ${properties?.productSelectedStore}`}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsStoreLocation)),
    definition: {
        displayName: "Store Location",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
